import * as z from "zod";
import type { LocalizationFlatTeamSettingKey } from "./catalog";

/** Compile-pinned to the catalog: a key here with no catalog entry is a type
 *  error, and vice versa. */
export const LocalizationFlatTeamSettingsShape = {
  "localization/enabled": z.boolean().nullish(),
} as const satisfies Record<LocalizationFlatTeamSettingKey, z.ZodTypeAny>;

export const LocalizationFlatTeamSettingsSchema = z.object(
  LocalizationFlatTeamSettingsShape,
);
